import * as React from 'react';
import type { SVGProps } from 'react';
const SvgFalconLink = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={20}
    height={20}
    fill="currentColor"
    viewBox="0 0 20 20"
    {...props}
  >
    <mask
      id="a"
      width={20}
      height={20}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'alpha',
      }}
    >
      <path fill="#D9D9D9" d="M0 0h20v20H0z" />
    </mask>
    <g mask="url(#a)">
      <path
        fill="currentColor"
        d="M9.375 9.583q.438 0 .74-.302t.302-.74q0-.436-.302-.739a1 1 0 0 0-.74-.302q-.437 0-.74.302a1 1 0 0 0-.301.74q0 .437.302.74.302.3.74.301m.75 3.146 3.459-3.458a.81.81 0 0 0 .25-.594.81.81 0 0 0-.25-.594.8.8 0 0 0-.594-.25.81.81 0 0 0-.594.25l-3.48 3.48a.76.76 0 0 0-.239.583.84.84 0 0 0 .26.583q.25.25.594.25.345 0 .594-.25m3 .604q.437 0 .74-.302.302-.302.302-.74 0-.436-.302-.739a1 1 0 0 0-.74-.302q-.437 0-.74.302a1 1 0 0 0-.301.74q0 .437.302.74.302.3.74.301m2.709 2.5H6.667q-.687 0-1.177-.49A1.6 1.6 0 0 1 5 14.168V2.5q0-.687.49-1.177t1.177-.49h5.146a1.65 1.65 0 0 1 1.166.48l4.042 4.041q.229.23.354.531.126.303.125.636v7.646q0 .687-.49 1.177-.489.49-1.177.49m0-9.166h-2.917q-.521 0-.886-.365a1.2 1.2 0 0 1-.364-.885V2.5h-5v11.667h9.167zm-12.5 12.5q-.688 0-1.178-.49a1.6 1.6 0 0 1-.49-1.177V6.667q0-.354.24-.594t.594-.24.594.24.24.594V17.5h8.333q.354 0 .594.24t.24.593-.24.594a.8.8 0 0 1-.594.24z"
      />
    </g>
  </svg>
);
export default SvgFalconLink;
